/**
 * WordPress dependencies
 */

export default {
	hookPrefix: 'team-member',
	layouts: [ {
		name: 'layout-1',
		label: 'Layout 1',
		imageAlign: 'center',
		titleAlign: 'center',
		socialIconAlign: 'center',
	}, {
		name: 'layout-2',
		label: 'Layout 2',
		imageAlign: 'center',
		titleAlign: 'left',
		socialIconAlign: 'left',
	}, {
		name: 'layout-3',
		label: 'Layout 3',
		imageAlign: 'center',
		titleAlign: 'right',
		socialIconAlign: 'right',
	}, {
		name: 'layout-4',
		label: 'Layout 4',
		imageAlign: 'center',
		titleAlign: 'left',
		socialIconAlign: 'left',
	}, {
		name: 'layout-5',
		label: 'Layout 5',
		imageAlign: 'center',
		titleAlign: 'center',
		socialIconAlign: 'center',
	} ],
};
